import { apiHelper } from '@/utils'
import { API } from '@/constants'

export const statusService = {
    getAllStatuses,
    updateStatusStatus,
    getStatus,
    updateStatus,
    createStatus,
};

const MODULE = {
    STATUS: 'rnd-risk-statuses',
}

// const API_URL = API.BASE_URL.replace('@serviceName', 'Status') + '/v1'
const API_URL = API.BASE_URL + '/v1'


export function getAllStatuses(filter) {

    const requestOptions = {
        params: {
            page: filter.pageNumber,
            size: filter.pageSize,
            name: filter.name,
            is_active: filter.isActive
        }
    }

    let array = filter.searchArray
    array.forEach((word, index) => {
        if (word != null || word != '') {
            var searchParam = `search_words[${index}]`
            requestOptions.params[searchParam] = word
        }
    })

    return apiHelper(API_URL).get(`/${MODULE.STATUS}`, requestOptions)
}


export function updateStatusStatus(data) {
    const requestOptions = {
        is_active: data.isActive
    }

    return apiHelper(API_URL).patch(`/${MODULE.STATUS}/${data.id}`, requestOptions)
}

export async function getStatus(id) {
    return await apiHelper(API_URL).get(`/${MODULE.STATUS}/${id}`)
}

export function updateStatus(data) {
    const requestOptions = {
        name: data.name,
    }
    return apiHelper(API_URL).put(`/${MODULE.STATUS}/${data.id}`, requestOptions)
}

export function createStatus(data) {
    const requestOptions = {
        name: data.name,
    }

    return apiHelper(API_URL).post(`/${MODULE.STATUS}`, requestOptions)
}